export default {"src":"/_next/static/image/public/images/flags/flag_32.043162ac29f868c8da534e5e77834adc.svg","height":16,"width":25};